import React, { useMemo } from 'react';
import classNames from 'classnames';
const CircleProgressBar = ({ current, max, centerContent, className, }) => {
    const percent = (current / max) * 100;
    const getRightPercent = useMemo(() => {
        if (percent <= 50) {
            const degRight = percent * 3.6;
            return { transform: `rotate(${degRight}deg)` };
        }
        else {
            return { transform: `rotate(180deg)` };
        }
    }, [percent]);
    const getLeftPercent = useMemo(() => {
        if (percent > 50 && percent <= 100) {
            const deg = (percent - 50) * 3.6;
            return { transform: `rotate(${deg}deg)` };
        }
        else if (percent > 100) {
            return { transform: `rotate(180deg)` };
        }
    }, [percent]);
    const css = classNames(className);
    return (React.createElement("div", { className: css },
        React.createElement("div", { className: 'circular-progress-bar' },
            React.createElement("div", { className: 'inner' }, centerContent && centerContent),
            React.createElement("div", { className: 'circle' },
                React.createElement("div", { className: 'bar right' },
                    React.createElement("div", { className: 'progress', style: getRightPercent })),
                React.createElement("div", { className: 'bar left' },
                    React.createElement("div", { className: 'progress ', style: getLeftPercent }))))));
};
export { CircleProgressBar };
//# sourceMappingURL=CircleProgressBar.js.map